import { onRemoveLink } from '../actions/publicActions';
import { updateCheckPermCount, removeCheckPerm } from '../actions/permissionCheckerInternalActions';
import { orchestrator } from 'satcheljs';
import getPermissionCheckerInfo from '../selectors/getPermissionCheckerInfo';

orchestrator(onRemoveLink, async actionMessage => {
    updateCheckPermCount(actionMessage.composeId, -1);

    let permissionCheckerInfo = getPermissionCheckerInfo(actionMessage.composeId);
    if (permissionCheckerInfo?.pendingCheckPermCount === 0) {
        removeCheckPerm(actionMessage.composeId);
    }
});
